import styled from 'styled-components';

import rem from 'polished/lib/helpers/rem';
import spacing from '@decisiv/design-tokens/lib/spacing';

import Flex from '@decisiv/ui-components/lib/components/Flex';
import { P, H3 } from '@decisiv/ui-components/lib/components/Typography';

export const Container = styled(Flex).attrs({
  paddingTop: 1.5,
  paddingX: 2,
  paddingBottom: 0.5,
})`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const Title = H3;

export const Left = styled(Flex)`
  align-items: center;
`;

export const Right = styled(Flex)`
  align-items: center;
  justify-content: flex-end;
`;

export const Actions = styled(Flex)`
  gap: ${rem(spacing.base * 0.5)};
  align-items: center;
`;

interface InformationProps {
  items: string[];
}

export const Information = ({ items }: InformationProps) => {
  return <P marginRight={2}>{items.join(' • ')}</P>;
};

export { DepotMenu } from './DepotMenu';
